import React, { FC } from 'react';
import { Box } from '@mui/material';
import { SizeTooltip } from '../../ui/size-tooltip';
import { FileProperties } from '../../../models/file.models';

export const FileDescription: FC<FileProperties> = ({ size, name }) => {
  return <div>
    {size && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <span>Initial size: <b>{size} Bytes</b></span>
      <SizeTooltip />
    </Box>}
    {name && <p>Full file name: {name}</p>}
  </div>
};
